// extracted by mini-css-extract-plugin
export default {"AlertWrapper":"Alert_AlertWrapper__QWJtV","Alert":"Alert_Alert__-gS6d","Title":"Alert_Title__xvZ1D","Text":"Alert_Text__w-biu"};